import { useState, useEffect, createContext } from "react";
import StoreLayout from "@/layouts/storeLayout";
import { BiBasket } from "react-icons/bi";
import { Filter } from "lucide-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { Card, CardContent } from "@/app/global-components/card";
import { Button } from "@/app/global-components/button";
import { Input } from "@/app/global-components/input";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/app/global-components/select";
// import { Slider as RangeSlider } from "@mui/material";
import { Checkbox } from "@/app/global-components/checkbox";
import { Label } from "@/app/global-components/label";
import { CiBoxList } from "react-icons/ci";
import { TbGridDots } from "react-icons/tb";
import useItems from "@/hooks/use-item";
// import useStore from "@/hooks/use-store";
// import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/app/global-components/dialog";
// import regionsData from "@/app/features/company/data/regions_lite.json";
// import citiesData from "@/app/features/company/data/cities_lite.json";
// import { cn } from "@/lib/utils";
import { useSearch } from "@/contexts/SearchContext";
import { useLocale } from "@/middleware";
import { useTranslate } from "@/locales";
// import { LANG } from "@/types";
// import { routes } from "@/consts";
import ProductCard from "./components/product-card";
// import { useSearch } from "@/contexts/SearchContext";

interface Product {
  id: string;
  categories: string[];
  companyId: string;
  name: string;
  store: {
    name: string;
    city?: string;
    region?: string;
  };
  price: number;
  minOrder: number;
  unit: string;
  images: string[];
  isFavorite?: boolean;
  quantity?: number;
}

// interface Store {
//   _id: string;
//   name: string;
//   bioEn: string;
//   bioAr: string;
//   email: string;
//   website: string;
//   imgUrl: string;
//   coverUrl: string;
//   rating: number;
//   reviewCount: number;
//   city?: string;
//   region?: string;
// }

interface FavoritesContextType {
  favorites: string[];
  toggleFavorite: (id: string) => void;
}

const FavoritesContext = createContext<FavoritesContextType>({
  favorites: [],
  toggleFavorite: () => {},
});

// function StoreCard({
//   store,
//   viewMode,
// }: {
//   store: Store;
//   viewMode: "grid" | "list";
// }) {
//   const navigate = useNavigate();
//   const { locale } = useLocale();
//   const { t } = useTranslate(locale);
//   if (viewMode === "list") {
//     return (
//       <Card className="overflow-hidden cursor-pointer transition-shadow duration-300 mb-4">
//         <div className="flex">
//           <div className="w-48 relative">
//             <img
//               src={store?.imgUrl}
//               alt={store?.name}
//               className="w-full h-full object-cover aspect-[4/3]"
//             />
//           </div>
//           <CardContent className="p-4 flex-1">
//             <div className="flex items-center gap-2 mb-2">
//               <div>
//                 <h3 className="font-semibold text-lg">{store?.name}</h3>
//                 <div className="flex items-center text-sm text-gray-500">
//                   <Star className="w-4 h-4 text-yellow-500 mr-1" />
//                   {/* {store.rating.toFixed(1)} ({store.reviewCount} reviews) */}
//                   5.0
//                 </div>
//               </div>
//             </div>
//             <p className="text-sm text-gray-600 mb-3">{store?.bioEn}</p>
//             <Button
//               className="w-full"
//               onClick={() => navigate(`/store/${store._id}`)}
//             >
//               {t("actions.viewStore")}
//             </Button>
//           </CardContent>
//         </div>
//       </Card>
//     );
//   }

//   return (
//     <Card className="overflow-hidden cursor-pointer transition-shadow duration-300 h-full">
//       <div className="relative aspect-[4/3]">
//         <img
//           src={store?.imgUrl}
//           alt={store?.name}
//           className="w-full h-full object-cover"
//         />
//       </div>
//       <CardContent className="p-4">
//         <div className="flex items-center gap-2 mb-2">
//           <div>
//             <h3 className="font-semibold">{store?.name}</h3>
//             <div className="flex items-center text-sm text-gray-500">
//               <Star className="w-4 h-4 text-yellow-500 mr-1" />
//             </div>
//           </div>
//         </div>
//         <p className="text-sm text-gray-600 line-clamp-2 mb-3">
//           {locale === LANG.AR
//             ? store?.bioAr.slice(0, 100)
//             : store?.bioEn.slice(0, 100)}
//         </p>
//         <Button
//           className="w-full !bg-black !text-white"
//           onClick={() => navigate(`${routes.store}/${store._id}`)}
//         >
//           {t("actions.viewStore")}
//         </Button>
//       </CardContent>
//     </Card>
//   );
// }

function FilterSection({
  filters,
  handleFilterChange,
  // handlePurchaseMethodChange,
  setFilters,
}: {
  filters: any;
  handleFilterChange: (key: string, value: any) => void;
  // handlePurchaseMethodChange: (
  //   method: "contact" | "directBuy",
  //   checked: boolean
  // ) => void;
  setFilters: (filters: any) => void;
}) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center gap-2 mb-6">
        <Filter className="w-5 h-5 text-gray-600" />
        <h3 className="text-lg font-semibold text-gray-800">
          {t("navigation.filters")}
        </h3>
      </div>

      <div className="space-y-6">
        {/* Favorites Filter */}
        <div className="p-4 bg-gradient-to-r from-red-50 to-pink-50 rounded-xl border border-red-100">
          <div className="flex gap-3 items-center">
            <Checkbox
              id="favorites"
              checked={filters.showFavorites}
              onCheckedChange={(checked) =>
                handleFilterChange("showFavorites", checked)
              }
              className="data-[state=checked]:bg-red-500 data-[state=checked]:border-red-500"
            />
            <Label
              htmlFor="favorites"
              className="text-sm font-medium text-gray-700 cursor-pointer"
            >
              {t("actions.showFavoritesOnly")}
            </Label>
          </div>
        </div>

        {/* Min Order Filter */}
        <div className="space-y-3">
          <Label className="text-sm font-semibold text-gray-700">
            {t("company.fields.minOrder")}
          </Label>
          <Input
            type="number"
            placeholder={t("company.placeholders.enterMinOrder")}
            value={filters.minOrder}
            onChange={(e) => handleFilterChange("minOrder", e.target.value)}
            className="w-full border-gray-200 focus:border-purple-500 focus:ring-purple-500 rounded-xl"
          />
        </div>

        {/* Price Range Filter */}
        <div className="space-y-3">
          <Label className="text-sm font-semibold text-gray-700">
            {t("company.fields.priceRange")}
          </Label>
          <div className="space-y-3">
            <div className="flex gap-3">
              <div className="flex-1">
                <Input
                  type="number"
                  value={filters.priceRange[0]}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 0 && value <= filters.priceRange[1]) {
                      handleFilterChange("priceRange", [
                        value,
                        filters.priceRange[1],
                      ]);
                    }
                  }}
                  className="w-full border-gray-200 focus:border-blue-500 focus:ring-blue-500 rounded-xl"
                  placeholder="Min"
                />
              </div>
              <div className="flex-1">
                <Input
                  type="number"
                  value={filters.priceRange[1]}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= filters.priceRange[0]) {
                      handleFilterChange("priceRange", [
                        filters.priceRange[0],
                        value,
                      ]);
                    }
                  }}
                  className="w-full border-gray-200 focus:border-blue-500 focus:ring-blue-500 rounded-xl"
                  placeholder="Max"
                />
              </div>
            </div>
            <div className="flex justify-between text-sm text-gray-500 px-2">
              <span>
                {filters.priceRange[0]} {t("currency")}
              </span>
              <span>
                {filters.priceRange[1]} {t("currency")}
              </span>
            </div>
          </div>
        </div>

        {/* Purchase Method Filter */}
        {/* <div className="space-y-3">
          <Label className="text-sm font-semibold text-gray-700">
            Purchase Method
          </Label>
          <div className="space-y-3">
            <div className="p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
              <div className="flex items-center gap-3">
                <Checkbox
                  id="contact"
                  checked={filters.purchaseMethod.contact}
                  onCheckedChange={(checked) =>
                    handlePurchaseMethodChange("contact", checked as boolean)
                  }
                  className="data-[state=checked]:bg-blue-500 data-[state=checked]:border-blue-500"
                />
                <Label
                  htmlFor="contact"
                  className="text-sm font-medium text-gray-700 cursor-pointer"
                >
                  Contact Supplier
                </Label>
              </div>
            </div>
            <div className="p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-100">
              <div className="flex items-center gap-3">
                <Checkbox
                  id="directBuy"
                  checked={filters.purchaseMethod.directBuy}
                  onCheckedChange={(checked) =>
                    handlePurchaseMethodChange("directBuy", checked as boolean)
                  }
                  className="data-[state=checked]:bg-green-500 data-[state=checked]:border-green-500"
                />
                <Label
                  htmlFor="directBuy"
                  className="text-sm font-medium text-gray-700 cursor-pointer"
                >
                  Direct Buy
                </Label>
              </div>
            </div>
          </div>
        </div> */}

        {/* Reset Filters Button */}
        <Button
          variant="outline"
          className="w-full py-3 rounded-xl border-gray-300 text-gray-700 hover:bg-gray-50 font-medium transition-all duration-200"
          onClick={() =>
            setFilters({
              minOrder: "",
              city: "",
              region: "",
              priceRange: [0, 1000000],
              purchaseMethod: {
                contact: true,
                directBuy: true,
              },
              showFavorites: false,
            })
          }
        >
          {t("actions.resetFilters")}
        </Button>
      </div>
    </div>
  );
}

function HomeMarketPlace() {
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");
  const [products, setProducts] = useState<Product[]>([]);
  // const [stores, setStores] = useState<Store[]>([]);
  // const [activeView, setActiveView] = useState<"products" | "stores">(
  //   "products"
  // );
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    minOrder: "",
    city: "",
    region: "",
    priceRange: [0, 1000000],
    purchaseMethod: {
      contact: true,
      directBuy: true,
    },
    showFavorites: false,
  });
  const [favorites, setFavorites] = useState<string[]>(() => {
    const savedFavorites = localStorage.getItem("favorites");
    return savedFavorites ? JSON.parse(savedFavorites) : [];
  });
  const { allMarketplaceProduct } = useItems();
  // const { getAllStores } = useStore();
  const { searchQuery, searchType, searchBrand, searchItem } = useSearch();

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (searchType === "products") {
        // Use allMarketplaceProduct with search parameter instead
        const results = await allMarketplaceProduct({ search: searchQuery });
        setProducts(results || []);
      } else {
      }
    };
    if (searchQuery) {
      fetchSearchResults();
    }
  }, [searchQuery, searchType]);

  useEffect(() => {
    const fetchData = async () => {
      // if (activeView === "products") {
      let searchParams: {
        brand?: string;
        search?: string;
        pageSize?: number;
        pageNumber?: number;
        withPaging?: boolean;
      } = {};

      // Add search parameters based on context
      if (searchBrand) {
        searchParams.brand = searchBrand;
      }
      if (searchItem) {
        searchParams.search = searchItem;
      }
      if (searchQuery) {
        searchParams.search = searchQuery;
      }

      const result = await allMarketplaceProduct(searchParams);
      setProducts(result || []);
      // } else {
      //   try {
      //     const response = await getAllStores();
      //     setStores(response || []);
      //   } catch (error) {
      //     console.error("Error fetching stores:", error);
      //   }
      // }
    };
    fetchData();
  }, [searchBrand, searchItem, searchQuery]);

  const toggleFavorite = (productId: string) => {
    setFavorites((prev) => {
      const newFavorites = prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId];
      localStorage.setItem("favorites", JSON.stringify(newFavorites));
      return newFavorites;
    });
  };

  const handleFilterChange = (key: string, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // const handlePurchaseMethodChange = (
  //   method: "contact" | "directBuy",
  //   checked: boolean
  // ) => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     purchaseMethod: {
  //       ...prev.purchaseMethod,
  //       [method]: checked,
  //     },
  //   }));
  // };

  const filteredProducts = products.filter((product) => {
    if (filters.showFavorites && !favorites.includes(product.id)) {
      return false;
    }
    if (filters.minOrder && product.minOrder < Number(filters.minOrder)) {
      return false;
    }
    if (filters.city && product.store?.city !== filters.city) {
      return false;
    }
    if (filters?.region && product.store?.region !== filters?.region) {
      return false;
    }
    if (
      product.price < filters.priceRange[0] ||
      product.price > filters.priceRange[1]
    ) {
      return false;
    }
    return true;
  });

  // Filter stores based on selected filters
  // const filteredStores = stores.filter((store) => {
  //   if (filters.city && store.city !== filters.city) {
  //     return false;
  //   }
  //   if (filters.region && store.region !== filters.region) {
  //     return false;
  //   }
  //   return true;
  // });
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <FavoritesContext.Provider value={{ favorites, toggleFavorite }}>
      <StoreLayout>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
          {/* Header Section */}
          <div className="border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
              <div className="flex justify-between items-center">
                {/* <div className="flex gap-3">
                  <Button
                    className={cn(
                      "md:px-6 px-2 !text-sm py-2 rounded-xl font-medium transition-all duration-200",
                      activeView === "products"
                        ? "bg-black text-white"
                        : "bg-gray-100 border border-gray-300 text-gray-700 hover:bg-gray-200"
                    )}
                    onClick={() => setActiveView("products")}
                  >
                    {t("supplier_sidebar.products")}
                  </Button>
                  <Button
                    className={cn(
                      "md:px-6 px-2 py-2 rounded-xl font-medium transition-all duration-200",
                      activeView === "stores"
                        ? "bg-black text-white shadow-lg"
                        : "bg-gray-100 border border-gray-300 text-gray-700 hover:bg-gray-200"
                    )}
                    onClick={() => setActiveView("stores")}
                  >
                    {t("supplier_sidebar.stores")}
                  </Button>
                </div> */}
                <div className="flex items-center gap-4">
                  <div className="flex gap-2">
                    <Button
                      variant="ghost"
                      size="icon"
                      className={`h-10 w-10 rounded-xl transition-all duration-200 ${
                        viewMode === "list"
                          ? "bg-black text-white shadow-lg"
                          : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                      }`}
                      onClick={() =>
                        setViewMode(viewMode === "list" ? "grid" : "list")
                      }
                    >
                      {viewMode === "list" ? (
                        <CiBoxList className="w-5 h-5" />
                      ) : (
                        <TbGridDots className="w-5 h-5" />
                      )}
                    </Button>
                  </div>
                  <div className="md:hidden">
                    <Button
                      variant="outline"
                      className="flex items-center justify-center gap-2 px-4 py-2 rounded-xl border-gray-300"
                      onClick={() => setIsFilterModalOpen(true)}
                    >
                      <Filter className="w-4 h-4" />
                      <span className="text-sm hidden md:block font-medium">
                        {t("navigation.filters")}
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="max-w-[1500px] mx-auto md:px-4 sm:px-6 lg:px-8 md:py-8">
            <div className="flex gap-8">
              {/* Desktop Filters */}
              <div className="hidden lg:block w-80 flex-shrink-0">
                <div className="sticky top-8">
                  <FilterSection
                    filters={filters}
                    handleFilterChange={handleFilterChange}
                    setFilters={setFilters}
                  />
                </div>
              </div>

              {/* Products/Stores Grid */}
              <div className="flex-1">
                {filteredProducts.length === 0 && (
                  <div className="flex flex-col justify-center items-center h-full py-20">
                    <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                      <BiBasket className="w-12 h-12 text-gray-400" />
                    </div>
                    <p className="text-gray-500 text-lg font-medium">
                      {t("marketplace.notFound")}
                    </p>
                    <p className="text-gray-400 text-sm mt-2">
                      Try adjusting your filters or search terms
                    </p>
                  </div>
                )}

                {/* {activeView === "products" ? ( */}
                <div
                  className={
                    viewMode === "grid"
                      ? "grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-6 gap-2"
                      : "space-y-6"
                  }
                >
                  {filteredProducts?.map((product) => (
                    <ProductCard
                      key={product.id}
                      product={product}
                      viewMode={viewMode}
                    />
                  ))}
                </div>
                {/* ) : (
                  <div
                    className={
                      viewMode === "grid"
                        ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6"
                        : "space-y-6"
                    }
                  >
                    {filteredStores?.map((store) => (
                      <StoreCard
                        key={store._id}
                        store={store}
                        viewMode={viewMode}
                      />
                    ))}
                  </div>
                )} */}
              </div>
            </div>
          </div>

          {/* Mobile Filter Modal */}
          <Dialog open={isFilterModalOpen} onOpenChange={setIsFilterModalOpen}>
            <DialogContent className="sm:max-w-[425px] max-h-[90vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle className="text-xl font-semibold">
                  {t("navigation.filters")}
                </DialogTitle>
              </DialogHeader>
              <FilterSection
                filters={filters}
                handleFilterChange={handleFilterChange}
                // handlePurchaseMethodChange={handlePurchaseMethodChange}
                setFilters={setFilters}
              />
            </DialogContent>
          </Dialog>
        </div>
      </StoreLayout>
    </FavoritesContext.Provider>
  );
}

export default HomeMarketPlace;
